import {List} from 'immutable';

import CollectionRecord from '@packages/systems/dynamo/records/CollectionRecord';
import Field from '@packages/systems/dynamo/records/Field';

export const SEARCH_EXCLUDE_PATH = ['data', 'search', 'exclude'] as const;
export const SEARCH_COLLECTION_ID = 'search';

export const HIGHLIGHTING_ENABLED_DEFAULT = true;

export const RESULTS_LENGTH_MIN = 1;
export const RESULTS_LENGTH_MAX = 60;
export const RESULTS_LENGTH_DEFAULT = 10;

export const SNIPPET_LENGTH_MIN = 10;
export const SNIPPET_LENGTH_MAX = 300;
export const SNIPPET_LENGTH_DEFAULT = 256;

export const SEARCH_COLLECTION = CollectionRecord({
  _id: SEARCH_COLLECTION_ID,
  slug: 'search',
  name: 'Search Index',
  fields: List.of(
    Field({name: 'Search Title', slug: 'title', type: 'PlainText'}),
    Field({
      name: 'Snippet',
      slug: 'highlighted-snippet',
      type: 'HighlightedText',
    }),
    Field({name: 'Search Description', slug: 'description', type: 'PlainText'}),
    Field({name: 'Page URL', slug: 'page-url', type: 'Link'}),
    Field({name: 'Search Image', slug: 'image', type: 'ImageRef'})
  ),
  pluralName: 'Search Results',
  singularName: 'Search Result',
});

const SEARCH_INDEX_STATUS_POLLING_TIMEOUT = 38 * 60 * 1000;
export const SEARCH_INDEX_STATUS_POLLING_INTERVAL = 5000;
export const SEARCH_INDEX_STATUS_MAX_TRIES = Math.floor(
  SEARCH_INDEX_STATUS_POLLING_TIMEOUT / SEARCH_INDEX_STATUS_POLLING_INTERVAL
);

export const FIRST_SEARCH_PUBLISH_MODAL_SEARCH_ALLOWED =
  'FIRST_SEARCH_PUBLISH_MODAL_SEARCH_ALLOWED';

// Site Search data source definition uses this as the
// externalKey of the Search Result binding context type.
export const SEARCH_RESULT_BINDING_CONTEXT_EXTERNAL_KEY = 'search-result-type';
